import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { bool, emit, text } from "../helpers";
import { parseEngineeringNumber } from "../../../engine/engineering";

let nextInputId = 0;
var root = $.from_html(`<label class="slex-input-label"> </label>`);
var root_1 = $.from_html(`<span class="slex-input-unit" aria-hidden="true"> </span>`);
var root_2 = $.from_html(`<div class="slex-input-description"> </div>`);
var root_3 = $.from_html(`<div class="slex-input-error" role="alert"> </div>`);
var root_4 = $.from_html(`<div class="slex-input-field"><!> <div class="slex-input-control"><input class="slex-input"/> <!></div> <!> <!></div>`);

export default function Input($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let value = $.state("");
	const fallbackId = `slex-input-${++nextInputId}`;
	const labelText = $.derived(() => text($.get(p).label));
	const unitText = $.derived(() => text($.get(p).unit));
	const descriptionText = $.derived(() => text($.get(p).description ?? $.get(p).help ?? $.get(p).hint));
	const errorText = $.derived(() => text($.get(p).error ?? $.get(p).errorMessage));
	const disabled = $.derived(() => bool($.get(p).disabled));
	const readonly = $.derived(() => bool($.get(p).readonly) || bool($.get(p).readOnly));
	const required = $.derived(() => bool($.get(p).required));
	const invalid = $.derived(() => bool($.get(p).invalid) || !!$.get(errorText));
	const componentId = $.derived(() => safeId($$props.componentName));
	const inputId = $.derived(() => text($.get(p).id) || ($.get(componentId) ? `slex-input-${$.get(componentId)}` : fallbackId));
	const descriptionId = $.derived(() => `${$.get(inputId)}-description`);
	const errorId = $.derived(() => `${$.get(inputId)}-error`);
	const explicitAriaLabel = $.derived(() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel));
	const computedAriaLabel = $.derived(() => $.get(explicitAriaLabel) || ($.get(labelText) ? "" : text($.get(p).placeholder)));

	const describedBy = $.derived(() => [
		$.get(descriptionText) ? $.get(descriptionId) : "",
		$.get(errorText) ? $.get(errorId) : ""
	].filter(Boolean).join(" "));

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(value, text(next.value), true);
	}));

	function safeId(value) {
		return value.trim().replace(/[^\w-]+/g, "-");
	}

	function inputType() {
		return text($.get(p).type, "text") === "engineering" ? "text" : text($.get(p).type, "text");
	}

	function update(event) {
		if ($.get(disabled) || $.get(readonly)) return;

		$.set(value, event.target.value, true);
		emit($$props.ctx, "change", text($.get(p).type, "text") === "engineering" ? parseEngineeringNumber($.get(value)) : $.get(value));
	}

	var div = root_4();
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			var label = root();
			var text_1 = $.child(label, true);

			$.reset(label);

			$.template_effect(() => {
				$.set_attribute(label, 'for', $.get(inputId));
				$.set_text(text_1, $.get(labelText));
			});

			$.append($$anchor, label);
		};

		$.if(node, ($$render) => {
			if ($.get(labelText)) $$render(consequent);
		});
	}

	var div_1 = $.sibling(node, 2);
	var input = $.child(div_1);

	$.remove_input_defaults(input);

	var node_1 = $.sibling(input, 2);

	{
		var consequent_1 = ($$anchor) => {
			var span = root_1();
			var text_2 = $.child(span, true);

			$.reset(span);
			$.template_effect(() => $.set_text(text_2, $.get(unitText)));
			$.append($$anchor, span);
		};

		$.if(node_1, ($$render) => {
			if ($.get(unitText)) $$render(consequent_1);
		});
	}

	$.reset(div_1);

	var node_2 = $.sibling(div_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var div_2 = root_2();
			var text_3 = $.child(div_2, true);

			$.reset(div_2);

			$.template_effect(() => {
				$.set_attribute(div_2, 'id', $.get(descriptionId));
				$.set_text(text_3, $.get(descriptionText));
			});

			$.append($$anchor, div_2);
		};

		$.if(node_2, ($$render) => {
			if ($.get(descriptionText)) $$render(consequent_2);
		});
	}

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_3 = ($$anchor) => {
			var div_3 = root_3();
			var text_4 = $.child(div_3, true);

			$.reset(div_3);

			$.template_effect(() => {
				$.set_attribute(div_3, 'id', $.get(errorId));
				$.set_text(text_4, $.get(errorText));
			});

			$.append($$anchor, div_3);
		};

		$.if(node_3, ($$render) => {
			if ($.get(errorText)) $$render(consequent_3);
		});
	}

	$.reset(div);

	$.template_effect(
		($0, $1, $2, $3, $4, $5, $6) => {
			$.set_attribute(div, 'data-invalid', $.get(invalid) ? "true" : undefined);
			$.set_attribute(div, 'data-required', $.get(required) ? "true" : undefined);
			$.set_attribute(div, 'data-readonly', $.get(readonly) ? "true" : undefined);
			$.set_attribute(div_1, 'data-has-unit', $.get(unitText) ? "true" : undefined);
			$.set_attribute(input, 'id', $.get(inputId));
			$.set_attribute(input, 'type', $0);
			$.set_attribute(input, 'inputmode', $1);
			$.set_attribute(input, 'name', $2);
			$.set_attribute(input, 'placeholder', $3);
			input.disabled = $.get(disabled);
			input.readOnly = $.get(readonly);
			input.required = $.get(required);
			$.set_attribute(input, 'min', $4);
			$.set_attribute(input, 'max', $5);
			$.set_attribute(input, 'step', $6);
			$.set_attribute(input, 'aria-label', $.get(computedAriaLabel) || undefined);
			$.set_attribute(input, 'aria-describedby', $.get(describedBy) || undefined);
			$.set_attribute(input, 'aria-invalid', $.get(invalid) ? "true" : undefined);
		},
		[
			() => inputType(),
			() => text($.get(p).type, "text") === "engineering" ? "decimal" : undefined,
			() => text($.get(p).name) || undefined,
			() => text($.get(p).placeholder),
			() => $.get(p).min === undefined ? undefined : text($.get(p).min),
			() => $.get(p).max === undefined ? undefined : text($.get(p).max),
			() => $.get(p).step === undefined ? undefined : text($.get(p).step)
		]
	);

	$.delegated('input', input, update);
	$.bind_value(input, () => $.get(value), ($$value) => $.set(value, $$value));
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['input']);